import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";

export default class CirclesRoute extends DiscourseRoute {
  @service circles;
  @service router;

  beforeModel() {
    if (!this.circles.userCanUseCircles) {
      this.router.replaceWith("/404");
    }
  }
}
